import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { consumerGuideUrl } from '../lib/consumerGuideLink';

/**
 * §6.5 섹션 3 — "user-management 를 자사 프로젝트로 리메이크" walkthrough 단계 요약.
 * 상세 절차는 docs/consumer-guide.md(#630) 딥링크로 심화.
 */
export function RemakeWalkthrough() {
  const { t } = useTranslation();
  const guideUrl = consumerGuideUrl();

  const steps = [
    t('gettingStartedGuide.walkthrough.steps.step1'),
    t('gettingStartedGuide.walkthrough.steps.step2'),
    t('gettingStartedGuide.walkthrough.steps.step3'),
    t('gettingStartedGuide.walkthrough.steps.step4'),
  ];

  return (
    <section aria-labelledby="gsg-walkthrough-heading">
      <h2
        id="gsg-walkthrough-heading"
        style={{ margin: '0 0 var(--spacing-3) 0', fontSize: 'var(--font-size-lg)', color: 'var(--color-text-primary)' }}
      >
        {t('gettingStartedGuide.walkthrough.heading')}
      </h2>
      <ol style={{ margin: 0, paddingLeft: 'var(--spacing-6)', display: 'flex', flexDirection: 'column', gap: 'var(--spacing-2)' }}>
        {steps.map((step, i) => (
          <li key={i} style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)' }}>
            {step}
          </li>
        ))}
        <li style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)' }}>
          {t('gettingStartedGuide.walkthrough.steps.step5')}
          {' — '}
          <Link to={guideUrl} style={{ color: 'var(--color-info)' }}>
            {t('gettingStartedGuide.paths.status.viewGuide')}
          </Link>
        </li>
      </ol>
    </section>
  );
}
